if (!customElements.get("m-image-layer")) {
  class MImageLayer extends HTMLElement {
    constructor() {
      super();
      this.enableParallax = false;
    }

    connectedCallback() {
      this.enableParallax = this.dataset.enableParallax === "true";
      if (!this.enableParallax) return;
      this.firstImage = this.querySelector(".m-image-with-text__image-first");
      this.secondImage = this.querySelector(".m-image-with-text__image-second");
      // By Libby: init parallax only when both images exist (avoids 'Required elements not found' error)
      if (!this.firstImage || !this.secondImage) return;
      if (typeof MinimogTheme === "undefined" || !MinimogTheme.Motion) return;
      MinimogTheme.Motion.inView(this, this.initAnimations.bind(this));
    }

    initAnimations() {
      this.animateElement(this.secondImage, [`translateY(30%)`, `translateX(0)`]);
      this.animateElement(this.firstImage, [`translateY(-5%)`, `translateX(0)`]);
    }

    animateElement(element, transforms) {
      MinimogTheme.Motion.scroll(
        MinimogTheme.Motion.animate(element, { transform: transforms }, { easing: "linear" }),
        {
          target: element,
          offset: ["start end", "end start"],
        }
      );
    }
  }

  customElements.define("m-image-layer", MImageLayer);
}
